import { getGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGet } from '@/common/api/client/sdk.gen'
import type { GenerateImageVariantListResponse } from '@/common/api/client/types.gen'

export type GenerateImageVariant = GenerateImageVariantListResponse

export const fetchGenerateImageVariants = async (
    orgId: string,
    categoryId: string
): Promise<GenerateImageVariant[]> => {
    const res = await getGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGet({
        path: { org_id: orgId, category_id: categoryId },
    })
    return res.data ?? []
}
